// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-content-card.match-history {
  display: flex;
  flex-direction: column;
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.dashboard-content-card.match-history .match-history-title {
  display: flex;
  gap: 1rem;
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 1rem;
  padding-left: 0.5rem;
}
.dashboard-content-card.match-history .match-history-indicators {
  display: flex;
  flex-direction: column;
  padding-left: 2.5rem;
  gap: 1rem;
}
.dashboard-content-card.match-history .match-history-indicators .status-component .status-title .status-count {
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderDashboard/DashboardMatchHistoryCard/index.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;AAAJ;AAEI;EACE,aAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;AAAN;AAGI;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AADN;AAKU;EACE,gBAAA;AAHZ","sourcesContent":[".dashboard-content-card {\n  &.match-history {\n    display: flex;\n    flex-direction: column;\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n\n    .match-history-title {\n      display: flex;\n      gap: 1rem;\n      font-size: 1.8rem;\n      font-weight: 700;\n      margin-bottom: 1rem;\n      padding-left: 0.5rem;\n    }\n\n    .match-history-indicators {\n      display: flex;\n      flex-direction: column;\n      padding-left: 2.5rem;\n      gap: 1rem;\n\n      .status-component {\n        .status-title {\n          .status-count {\n            font-weight: 700;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
